import React from 'react'
import BloodMain from '../components/blood-testing/BloodMain'
import BloodGeneral from '../components/blood-testing/BloodGeneral'
import BloodImportance from '../components/blood-testing/BloodImportance'
import BloodTestingPanel from '../components/blood-testing/BloodTestingPanel'
import BloodTestImportance from '../components/blood-testing/BloodTestImportance'
import BloodVariousTests from '../components/blood-testing/BloodVariousTests'
import TopHeader from '../layout/TopHeader'
import MainHeader from '../layout/MainHeader'
import Footer from '../layout/Footer'
import CopyRight from '../layout/CopyRight'
import MainResHeader from '../layout/MainResHeader'
import { useEffect } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'

const BloodTestingPage = () => {

  useEffect(()=>{
    window.scrollTo(0,0)
  },[])

  return (
    <div style={{ overflow:'hidden'}}>

    <HelmetProvider>
        <Helmet prioritizeSeoTags>
        <title>Accurate Blood Testing Lab In Chicago, AL | United Lab Care</title>
        <meta name="description" content="United Lab Care offers secure and confidential blood work services including CBC, CMP, and HIV tests. Get peace of mind. Book now!" />
	<link rel="canonical" href="https://unitedlabcare.com/blood-test-lab-in-chicago/" />
	<meta property="og:locale" content="en_US" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content="Accurate Blood Testing Lab In Chicago, AL | United Lab Care" />
	<meta property="og:description" content="United Lab Care offers secure and confidential blood work services including CBC, CMP, and HIV tests. Get peace of mind. Book now!" />
	<meta property="og:url" content="https://unitedlabcare.com/blood-test-lab-in-chicago/" />
	<meta property="og:site_name" content="United Lab Care" />
	<meta property="article:modified_time" content="2023-07-11T11:00:37+00:00" />
	<meta property="og:image" content="https://unitedlabcare.com/wp-content/uploads/2023/06/icon1-ULC-General-Blood-Work.png" />
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:label1" content="Est. reading time" />
	<meta name="twitter:data1" content="8 minutes" />
        </Helmet>
    </HelmetProvider>

        <TopHeader/>
        {/* <MainHeader/> */}
        <MainResHeader/>
        
        <BloodMain/>
        <BloodGeneral/>
        <BloodImportance/>
        <BloodTestingPanel/>
        <BloodTestImportance/>
        <BloodVariousTests/>

        <Footer/>
        <CopyRight/>
    </div>
  )
}

export default BloodTestingPage